import { defineMessages } from "react-intl";
export default defineMessages({
    aboveHorizonAllDay: {
        id: "astral.aboveHorizonAllDay",
        defaultMessage: "Above the horizon all day",
    },
    aboveTheHorizon: {
        id: "astral.aboveTheHorizon",
        defaultMessage: "above the horizon",
    },
    apparentSize: {
        id: "astral.apparentSize",
        defaultMessage: "Apparent size",
    },
    astronomicalDawn: {
        id: "astral.astronomicalDawn",
        defaultMessage: "Astronomical dawn",
    },
    astronomicalDusk: {
        id: "astral.astronomicalDusk",
        defaultMessage: "Astronomical dusk",
    },
    astronomicalSunPhase: {
        id: "astral.astronomicalSunPhase",
        defaultMessage: "Astronomical {sunPhase}",
    },
    belowHorizonAllDay: {
        id: "astral.belowHorizonAllDay",
        defaultMessage: "Below the horizon all day",
    },
    belowHorizonSince: {
        id: "astral.belowHorizonSince",
        defaultMessage: "Below the horizon since {time}",
    },
    brightAllNight: {
        id: "astral.brightAllNight",
        defaultMessage: "Bright all night — never fully dark",
    },
    brightestMoment: {
        id: "astral.brightestMoment",
        defaultMessage: "Brightest moment",
    },
    civilDawn: {
        id: "astral.civilDawn",
        defaultMessage: "Civil dawn",
    },
    civilDusk: {
        id: "astral.civilDusk",
        defaultMessage: "Civil dusk",
    },
    civilSunPhase: {
        id: "astral.civilSunPhase",
        defaultMessage: "Civil {sunPhase}",
    },
    darkSkyWindow: {
        id: "astral.darkSkyWindow",
        defaultMessage: "Dark sky {from} → {to} · {duration} without the moon",
    },
    dawn: {
        id: "astral.dawn",
        defaultMessage: "Dawn",
    },
    dayLength: {
        id: "astral.dayLength",
        defaultMessage: "Day length",
    },
    dayOfCycle: {
        id: "astral.dayOfCycle",
        defaultMessage: "day {day} of {total}",
    },
    daylightThroughTheYear: {
        id: "astral.daylightThroughTheYear",
        defaultMessage: "Daylight through the year",
    },
    doesNotOccurToday: {
        id: "astral.doesNotOccurToday",
        defaultMessage: "Does not occur today",
    },
    dusk: {
        id: "astral.dusk",
        defaultMessage: "Dusk",
    },
    earliestSunrise: {
        id: "astral.earliestSunrise",
        defaultMessage: "Earliest sunrise",
    },
    earliestSunset: {
        id: "astral.earliestSunset",
        defaultMessage: "Earliest sunset",
    },
    equinox: {
        id: "astral.equinox",
        defaultMessage: "Equinox",
    },
    equinoxIn: {
        id: "astral.equinoxIn",
        defaultMessage: "Equinox in {days, plural, one {# day} other {# days}}",
    },
    evening: {
        id: "astral.evening",
        defaultMessage: "Evening",
    },
    exactPhaseAt: {
        id: "astral.exactPhaseAt",
        defaultMessage: "Exact at {time}",
    },
    firstQuarter: {
        id: "astral.firstQuarter",
        defaultMessage: "First quarter",
    },
    firstSunriseIn: {
        id: "astral.firstSunriseIn",
        defaultMessage: "First sunrise in {days, plural, one {# day} other {# days}}",
    },
    firstSunsetIn: {
        id: "astral.firstSunsetIn",
        defaultMessage: "First sunset in {days, plural, one {# day} other {# days}}",
    },
    fullMoon: {
        id: "astral.fullMoon",
        defaultMessage: "Full moon",
    },
    goldenHourBegins: {
        id: "astral.goldenHourBegins",
        defaultMessage: "Golden hour begins",
    },
    goldenHourEnds: {
        id: "astral.goldenHourEnds",
        defaultMessage: "Golden hour ends",
    },
    highestPoint: {
        id: "astral.highestPoint",
        defaultMessage: "Highest point",
    },
    inDays: {
        id: "astral.inDays",
        defaultMessage: "in {days, plural, one {# day} other {# days}}",
    },
    lastQuarter: {
        id: "astral.lastQuarter",
        defaultMessage: "Last quarter",
    },
    latestSunrise: {
        id: "astral.latestSunrise",
        defaultMessage: "Latest sunrise",
    },
    latestSunset: {
        id: "astral.latestSunset",
        defaultMessage: "Latest sunset",
    },
    longestDay: {
        id: "astral.longestDay",
        defaultMessage: "Longest day",
    },
    lowestPoint: {
        id: "astral.lowestPoint",
        defaultMessage: "Lowest point",
    },
    midday: {
        id: "astral.midday",
        defaultMessage: "Midday",
    },
    midnightSun: {
        id: "astral.midnightSun",
        defaultMessage: "Midnight sun",
    },
    midnightSunPeriod: {
        id: "astral.midnightSunPeriod",
        defaultMessage: "Midnight sun",
    },
    moon: {
        id: "astral.moon",
        defaultMessage: "Moon",
    },
    moonAltitude: {
        id: "astral.moonAltitude",
        defaultMessage: "Altitude",
    },
    moonDirection: {
        id: "astral.moonDirection",
        defaultMessage: "Azimuth",
    },
    moonDistance: {
        id: "astral.moonDistance",
        defaultMessage: "Distance",
    },
    moonPhases: {
        id: "astral.moonPhases",
        defaultMessage: "Moon phases",
    },
    moonrise: {
        id: "astral.moonrise",
        defaultMessage: "Moonrise",
    },
    moonset: {
        id: "astral.moonset",
        defaultMessage: "Moonset",
    },
    morning: {
        id: "astral.morning",
        defaultMessage: "Morning",
    },
    nauticalDawn: {
        id: "astral.nauticalDawn",
        defaultMessage: "Nautical dawn",
    },
    nauticalDusk: {
        id: "astral.nauticalDusk",
        defaultMessage: "Nautical dusk",
    },
    nauticalSunPhase: {
        id: "astral.nauticalSunPhase",
        defaultMessage: "Nautical {sunPhase}",
    },
    newMoon: {
        id: "astral.newMoon",
        defaultMessage: "New moon",
    },
    nextDay: {
        id: "astral.nextDay",
        defaultMessage: "+1 day",
    },
    nextRise: {
        id: "astral.nextRise",
        defaultMessage: "next rise {time}",
    },
    noSunriseToday: {
        id: "astral.noSunriseToday",
        defaultMessage: "No sunrise today",
    },
    noon: {
        id: "astral.noon",
        defaultMessage: "Noon",
    },
    nowAtBearing: {
        id: "astral.nowAtBearing",
        defaultMessage: "now {altitude} · azimuth {direction}",
    },
    ofDaylightLeft: {
        id: "astral.ofDaylightLeft",
        defaultMessage: "of daylight left",
    },
    overTheNextThreeWeeks: {
        id: "astral.overTheNextThreeWeeks",
        defaultMessage: "over the next 3 weeks",
    },
    percentLit: {
        id: "astral.percentLit",
        defaultMessage: "{percent} lit",
    },
    polarNight: {
        id: "astral.polarNight",
        defaultMessage: "Polar night",
    },
    polarNightPeriod: {
        id: "astral.polarNightPeriod",
        defaultMessage: "Polar night",
    },
    remainingDaylight: {
        id: "astral.remainingDaylight",
        defaultMessage: "Remaining daylight",
    },
    rightNow: {
        id: "astral.rightNow",
        defaultMessage: "Right now",
    },
    shortestDay: {
        id: "astral.shortestDay",
        defaultMessage: "Shortest day",
    },
    solarNoon: {
        id: "astral.solarNoon",
        defaultMessage: "Solar noon",
    },
    solstice: {
        id: "astral.solstice",
        defaultMessage: "Solstice",
    },
    sunBelowHorizon: {
        id: "astral.sunBelowHorizon",
        defaultMessage: "Sun {degrees}° below the horizon",
    },
    sunEvents: {
        id: "astral.sunEvents",
        defaultMessage: "Sun events",
    },
    sunNeverSets: {
        id: "astral.sunNeverSets",
        defaultMessage: "Sun never sets",
    },
    sunrise: {
        id: "astral.sunrise",
        defaultMessage: "Sunrise",
    },
    sunriseAndSunset: {
        id: "astral.sunriseAndSunset",
        defaultMessage: "Sunrise and sunset",
    },
    sunriseAt: {
        id: "astral.sunriseAt",
        defaultMessage: "Sunrise at {time}",
    },
    sunset: {
        id: "astral.sunset",
        defaultMessage: "Sunset",
    },
    sunsetAt: {
        id: "astral.sunsetAt",
        defaultMessage: "Sunset at {time}",
    },
    thisYearAtNorth: {
        id: "astral.thisYearAtNorth",
        defaultMessage: "This year at {degrees}°N",
    },
    thisYearAtSouth: {
        id: "astral.thisYearAtSouth",
        defaultMessage: "This year at {degrees}°S",
    },
    tonight: {
        id: "astral.tonight",
        defaultMessage: "Tonight",
    },
    totalDaylight: {
        id: "astral.totalDaylight",
        defaultMessage: "Total daylight",
    },
    upFor: {
        id: "astral.upFor",
        defaultMessage: "Up for {duration}",
    },
    usableLight: {
        id: "astral.usableLight",
        defaultMessage: "Usable light",
    },
    vsAverage: {
        id: "astral.vsAverage",
        defaultMessage: "{percent} vs average",
    },
    vsYesterday: {
        id: "astral.vsYesterday",
        defaultMessage: "vs yesterday",
    },
    waningCrescent: {
        id: "astral.waningCrescent",
        defaultMessage: "Waning crescent",
    },
    waningGibbous: {
        id: "astral.waningGibbous",
        defaultMessage: "Waning gibbous",
    },
    waxingCrescent: {
        id: "astral.waxingCrescent",
        defaultMessage: "Waxing crescent",
    },
    waxingGibbous: {
        id: "astral.waxingGibbous",
        defaultMessage: "Waxing gibbous",
    },
});
